export default __webpack_public_path__ + "static/media/OolaLifeLearnMore.d1983223.mp4";